import {BaseFormModel} from './base-form-model';
import {DonationProgram} from './donation-program';

export class Donation extends BaseFormModel<Donation> {
    id: number;
    amount: number;
    donationProgram: DonationProgram;
    refunded: boolean;
}
